import moment from 'moment';
import React, { Fragment, Component } from 'react';
import Avatar from 'react-avatar';
import Like from './Like';
import Replies from './Replies';
import 'bootstrap';

export default class CommentCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showReply: false,
    };
  }

  enabledReply = () => {
    if (!this.state.showReply) {
      this.setState({ showReply: true });
    } else {
      this.setState({ showReply: false });
    }
  };
  render() {
    const { comment, index, offer } = this.props;
    const { showReply } = this.state;

    return (
      <Fragment>
        <div className='comment-box'>
          <div className='outer-box'>
            <div className='w-row'>
              <div className='column-2 w-col w-col-8'>
                <div className='single-comment'>
                  <div className='single-comment-box'>
                    <div className='img-holder'>
                      <Avatar
                        color={Avatar.getRandomColor('sitebase', [
                          'red',
                          'green',
                          'blue',
                        ])}
                        name={comment.postedBy}
                        size='100'
                        round={true}
                      />
                    </div>
                    <div className='text-holder'>
                      <div className='nameHolder'>
                        <h3>{comment.postedBy}</h3>
                      </div>
                      <h6>
                        {moment(comment.createdAt).fromNow()} |{' '}
                        <span style={{ opacity: 0.5 }}>
                          {' '}
                          Replies ({comment.replies && comment.replies.length})
                        </span>
                      </h6>
                      <p>{comment.content}</p>
                      <div className='reply-button'>
                        {/* <button onClick={() => this.enabledReply()}>
                          Reply
                        </button> */}
                        <Like comment={comment} offer={offer} />
                      </div>
                    </div>
                  </div>
                </div>

                <Replies
                  comment={comment}
                  index={index}
                  offer={offer}
                  showReply={showReply}
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OfferOverview/Comments/CommentCard.js